import React from 'react';
import clsx from 'clsx';
import IMLogo from 'assets/images/insuranceMenuLogo.svg';

import { createStyles } from './styles';

export interface PoweredByIMProps {
  className?: string;
}

const PoweredByIM = ({ className }: PoweredByIMProps): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={clsx(classes.poweredByBlock, className)}>
      <p className={classes.poweredByTitle}>Powered by</p>
      <div className={classes.imLogoWrapper}>
        <img src={IMLogo as string} alt="Insurance Menu Logo" />
      </div>
    </div>
  );
};

export default PoweredByIM;
